export default __webpack_public_path__ + "static/salon-vid-n-422528e7f9945239897682121fc12f41.mp4";